import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem } from 'react-bootstrap';
import './MenuIconItem.css';
import withSounds from '../../containers/withSounds';

function MenuIconItem({ title, url, ...otherProps }) {
  return (
    <div className="menu-icon-item" {...otherProps}>
      <MenuItem href={url}>{title}</MenuItem>
    </div>
  );
}

MenuIconItem.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string
};

export default withSounds({ mouseEnterSound: true })(MenuIconItem);



// WEBPACK FOOTER //
// ./src/components/MenuIconItem/index.js